// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import * as semver from 'semver';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useJsonApiClient } from '../../../contexts/JsonApiContext';

const useIsPackageAvailableFrom: (
  packageName: string,
  parties: string[],
  availableFromVersion: string,
) => UseQueryResult<boolean, string> = (packageName, parties, availableFromVersion) => {
  const jsonApi = useJsonApiClient();
  return useQuery({
    queryKey: ['queryIsAvailableFrom', jsonApi, packageName, parties, availableFromVersion],
    queryFn: async () => {
      const preferredPackageVersion =
        await jsonApi.getV2InteractiveSubmissionPreferredPackageVersion(packageName, parties);
      const version = preferredPackageVersion.packagePreference?.packageReference?.packageVersion;
      return version ? semver.gte(version, availableFromVersion) : false;
    },
    refetchInterval: false,
  });
};

export default useIsPackageAvailableFrom;
